import { Box, BoxProps, TextFieldProps } from '@mui/material'
import React from 'react'
import { Span, TextFieldNumber } from 'src/components'
interface Props extends BoxProps {
  label: string
  inputProps: TextFieldProps & {
    error?: boolean
  }
}
const NumberRestrictionInput: React.FC<Props> = ({
  label,
  inputProps: { inputProps: muiInputProps, sx: inputSx, error, ...inputProps },
  sx,
  ...boxProps
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        ...sx
      }}
      {...boxProps}
    >
      <Span>{label}</Span>
      <TextFieldNumber
        inputProps={{ min: 0, ...muiInputProps }}
        sx={{
          marginLeft: '1rem',
          width: '10rem',
          ...inputSx
        }}
        error={!!error}
        {...inputProps}
      />
    </Box>
  )
}
export default NumberRestrictionInput
